import React, { useState, useEffect, useCallback, memo } from "react";
import maleCandidate from "../../assets/maleCandidate.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { API_URL } from "../../constants";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../src/services/serviceCaller";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch } from "react-redux";
import {
  updateDashboardApiData,
  updateNavbarHeading,
} from "../../../../Frontend/src/constants/layout/store/filterSlice";
import KPICard from "./DashboardComponent/KpiCardComponent/KPICard";
import AlertSection from "./DashboardComponent/AlertComponent/AlertSection";
import CelebrationSection from "./DashboardComponent/CelebrationComponent/CelebrationSection";
import LeaveSummarySection from "./DashboardComponent/LeaveSummmaryComponent/LeaveSummarySection";
import LeaderboardSection from "./DashboardComponent/LeaderBoardComponent/LeaderBoardSection";
import FeedItem from "./DashboardComponent/FeedItem/FeedItem";
import KnowledgeBaseItem from "./DashboardComponent/KnowledgeBaseItem/KnowledgeBaseItem";
import SnowflakeIcon from "../../assets/SnowflakeIcon.svg";
import AIIcon from "../../assets/AIIcon.svg";
import ITTipsIcon from "../../assets/ITTipsIcon.svg";
import AdminIcon from "../../assets/AdminIcon.svg";
import PBIcon from "../../assets/PowerBIWhiteLogo.svg";
import DSPulseIcon from "../../assets/DSLogo.svg";
import moment from "moment";
import DashboardSkeleton from "../../components/Skeletons/Dashboard_Skeleton";

const Dashboard = ({ isSidebarOpen }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Dashboard"));
  }, [dispatch]);

  const navigate = useNavigate();
  const [birthday, setBirthday] = useState([]);
  const [anniversaries, setAnniversay] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [sixMonths, setSixMonth] = useState([]);
  const [threemonths, setThreeMonth] = useState([]);
  const [tweleMonth, setTweleMonth] = useState([]);
  const [knowledgeBase, setKnowledgeBase] = useState([]);
  const [alert, setAlert] = useState([]);
  const [KPI, setKPI] = useState([]);
  const [kpiInfo, setKPIInfo] = useState([]);
  const [feeds, setFeeds] = useState([]);
  const [replyInput, setReplyInput] = useState({});
  const [activeReplyId, setActiveReplyId] = useState(null);
  const [visibleCards, setVisibleCards] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedReply, setSelectedReply] = useState({
    feedId: null,
    replyId: null,
  });
  const [leaderOpen, setLeaderOpen] = useState(true);
  const [leaveOpen, setLeaveOpen] = useState(false);
  const [snowFlake, setSnowFlake] = useState([]);
  const [weeklyDose, setWeeklyDose] = useState([]);
  const [itTips, setITTips] = useState([]);
  const [adminTips, setAdminTips] = useState([]);
  const [powerBytes, setpowerbytes] = useState([]);
  const [dsPulse, setdspulse] = useState([]);

  const mainColClass = isSidebarOpen ? "col-xl-10 pr-0" : "col-xl-9 pr-0";
  const sideColClass = isSidebarOpen ? "col-xl-2" : "col-xl-3";

  useEffect(() => {
    const handleResize = () => {
      const isTargetScreenSize = window.matchMedia(
        "(min-width: 1600px) and (max-width: 2199px)"
      ).matches;

      if (isTargetScreenSize) {
        // Force both sections open in this screen range
        setLeaderOpen(true);
        setLeaveOpen(true);
      }
    };

    // Initial check + listen for resize events
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const AchevierSettings = React.useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: isSidebarOpen ? 1 : 3,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      dotsClass: "slick-dots custom-slider-dots",
      customPaging: function (i) {
        return <div className="dot-indicator" />;
      },
      vertical: isSidebarOpen,
      verticalSwiping: isSidebarOpen,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: isSidebarOpen ? 1 : 2,
            vertical: false,
            verticalSwiping: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            vertical: false,
            verticalSwiping: false,
          },
        },
      ],
    }),
    [isSidebarOpen]
  );
  useEffect(() => {
    if (KPI?.length > 0) {
      let i = 0;
      const interval = setInterval(() => {
        i++;
        setVisibleCards(i);
        if (i >= KPI.length) {
          clearInterval(interval);
        }
      }, 300);
      return () => clearInterval(interval);
    }
  }, [KPI]);
  const toggleLeaveOpen = () => {
    setLeaveOpen((prev) => !prev);
    if (!leaveOpen) {
      setLeaderOpen(false);
    }
  };

  // When leader section opens, close leave section
  const toggleLeaderOpen = () => {
    setLeaderOpen((prev) => !prev);
    if (!leaderOpen) {
      setLeaveOpen(false);
    }
  };
  // Fetch dashboard data
  const fetchDashboardDetails = useCallback(async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}nest/dashboard`);

      dispatch(updateDashboardApiData(response?.data?.alertNotification));

      // Feed data
      const feedData = response?.data?.feeds;
      setFeeds(
        feedData && typeof feedData === "object" ? Object.values(feedData) : []
      );

      // KPI Data
      setKPI(response?.data?.KPI?.data || []);
      setKPIInfo(response?.data?.KPI || []);

      // Birthday Data
      const birthdayData =
        response?.data?.birthdayAnniversaryDetails?.birthday?.map(
          (item, index) => ({
            id: index + 1,
            name: item.text || "Unknown",
            image: item.FilePath || maleCandidate,
          })
        );
      setBirthday(birthdayData || []);

      // Anniversary Data
      const anniversaryData =
        response?.data?.birthdayAnniversaryDetails?.anniversary?.map(
          (item, index) => ({
            id: index + 1,
            name: item.text || "Unknown",
            image: item.FilePath || maleCandidate,
          })
        );
      setAnniversay(anniversaryData || []);

      // Leave Summary Details
      setLeaveData(response?.data?.leaveSummary || []);

      // Leader Board Details
      setSixMonth(response?.data?.leaderboard?.TopAchieversSixthMonth || []);
      setThreeMonth(response?.data?.leaderboard?.TopAchieversThirdMonth || []);
      setTweleMonth(response?.data?.leaderboard?.leaderboard || []);

      // Knowledge Base data
      setKnowledgeBase(response?.data?.knowledgeBase || []);

      // Alert Data
      setAlert(response?.data?.alerts || []);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching Dashboard Details:", error);
      setPageLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardDetails();
  }, [fetchDashboardDetails]);

  const getUniqueRanks = useCallback((data) => {
    if (!Array.isArray(data)) {
      console.error("Invalid data: Expected an array");
      return [];
    }

    const uniqueRanks = new Set();

    const filteredData = data.filter((item) => {
      if (
        item &&
        typeof item.rank === "number" &&
        [1, 2, 3].includes(item.rank) &&
        !uniqueRanks.has(item.rank)
      ) {
        uniqueRanks.add(item.rank);
        return true;
      }
      return false;
    });

    const formatName = (fullName) => {
      if (typeof fullName !== "string") return "";
      const nameParts = fullName.trim().split(" ");
      return nameParts.length > 2
        ? `${nameParts[0]} ${nameParts[nameParts.length - 1]}`
        : fullName;
    };

    return filteredData
      .map((item) => ({
        ...item,
        Name: formatName(item?.Name),
      }))
      .sort((a, b) => {
        if (a.Name?.toLowerCase() === b.Name?.toLowerCase()) {
          return a.rank - b.rank;
        }
        return a.Name?.localeCompare(b.Name);
      });
  }, []);

  const uniqueRanksThreeMonths = getUniqueRanks(threemonths);
  const uniqueRanksSixMonths = getUniqueRanks(sixMonths);
  const uniqueRanksTwelveMonths = getUniqueRanks(tweleMonth);

  // Memoized event handlers
  const handleReplyClick = useCallback(
    (feedID) => {
      setActiveReplyId(activeReplyId === feedID ? null : feedID);
    },
    [activeReplyId]
  );

  const handleInputChange = useCallback((e, feedID) => {
    setReplyInput((prev) => ({ ...prev, [feedID]: e.target.value }));
  }, []);

  const handlePostReply = useCallback(
    async (feedID) => {
      const replyText = replyInput[feedID]?.trim();

      if (!replyText) {
        toast.error("Reply cannot be empty.", { position: "top-right" });
        return;
      }

      const payload = {
        P_ParentID: feedID,
        P_MsgDetails: replyText,
      };

      try {
        await PostFormServiceCaller(
          `${API_URL}nest/dashboard/reply-feeds`,
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        fetchDashboardDetails();
        setReplyInput((prev) => ({ ...prev, [feedID]: "" }));
        setActiveReplyId(null);
      } catch (error) {
        console.error("Error posting reply:", error);
      }
    },
    [replyInput, fetchDashboardDetails]
  );

  const handleDeleteReply = useCallback(
    async (feedId, replyId) => {
      try {
        await PostFormServiceCaller(
          `${API_URL}nest/dashboard/delete-feeds-reply?P_ID=${replyId}&P_ParentID=${feedId}`,
          "delete"
        );

        setFeeds((prevFeeds) =>
          prevFeeds.map((feed) => {
            if (feed.ID === feedId) {
              const updatedReplies = { ...feed.Reply };
              delete updatedReplies[replyId];
              return { ...feed, Reply: updatedReplies };
            }
            return feed;
          })
        );

        toast.success("Comment Deleted Successfully");
        fetchDashboardDetails();
      } catch (error) {
        console.error("Error deleting reply:", error);
        toast.error("Failed to delete comment");
      }
    },
    [fetchDashboardDetails]
  );

  const formatCount = useCallback((count) => {
    if (!count) return "0";
    if (count >= 1000000) return Math.floor(count / 1000000) + "M";
    if (count >= 1000) return Math.floor(count / 1000) + "K";
    return count;
  }, []);

  // Knowledge Sharing section
  useEffect(() => {
    fetchSharingData();
  }, []);
  const fetchSharingData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/dashboard/knowledge-sharing`
      );
      const sharingData = response?.data?.tips;
      //Snowflakes Data
      const SnowflakeData = sharingData?.snowFlake[0];
      setSnowFlake(SnowflakeData || []);
      // AI Dose Data
      const AIData = sharingData?.weeklyDose[0];
      setWeeklyDose(AIData || []);
      // IT Tips Data
      const ITData = sharingData?.itTips[0];
      setITTips(ITData || []);
      // Admin Tips Data
      const adminData = sharingData?.adminFeeds[0];
      setAdminTips(adminData || []);
       // Power Bytes
      const powerBytes = sharingData?.powerbytes[0];
      setpowerbytes(powerBytes || []);
      // DS Pulse
      const dsPulse = sharingData?.dspulse[0];
      setdspulse(dsPulse || []);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  if (pageLoading) {
    return <DashboardSkeleton />;
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row mt-2 mx-0">
          <div className="col-12 col-lg-8 ps-0 pe-0 pe-lg-2">
            <KPICard
              KPI={KPI}
              kpiInfo={kpiInfo}
              mainColClass={mainColClass}
              sideColClass={sideColClass}
              AchevierSettings={AchevierSettings}
              isSidebarOpen={isSidebarOpen}
            />

            <div className="row mt-2 mx-0">
              <div className="container-fluid p-0">
                <div className="p-0 forum-tab">
                  <ul
                    className="nav feed-nav-tabs overflow multi-tabs"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link forum-tab-btn active"
                        id="feed-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#feed"
                        type="button"
                        role="tab"
                        aria-controls="feed"
                        aria-selected="true"
                      >
                        Feeds
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link forum-tab-btn"
                        id="base-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#base"
                        type="button"
                        role="tab"
                        aria-controls="base"
                        aria-selected="false"
                      >
                        Knowledge Base
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link forum-tab-btn"
                        id="share-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#share"
                        type="button"
                        role="tab"
                        aria-controls="share"
                        aria-selected="false"
                      >
                        Tech & Tips
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="forum_sect">
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="feed"
                      role="tabpanel"
                      aria-labelledby="feed-tab"
                    >
                      <div>
                        {feeds?.length > 0 ? (
                          feeds.map((feed) => (
                            <FeedItem
                              key={feed.ID}
                              feed={feed}
                              activeReplyId={activeReplyId}
                              replyInput={replyInput}
                              handleReplyClick={handleReplyClick}
                              handleInputChange={handleInputChange}
                              handlePostReply={handlePostReply}
                              setSelectedReply={setSelectedReply}
                              setShowDeleteModal={setShowDeleteModal}
                            />
                          ))
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show"
                      id="base"
                      role="tabpanel"
                      aria-labelledby="base-tab"
                    >
                      {knowledgeBase?.map((item, index) => (
                        <KnowledgeBaseItem key={index} item={item} />
                      ))}
                    </div>
                    <div
                      className="tab-pane fade show"
                      id="share"
                      role="tabpanel"
                      aria-labelledby="share-tab"
                    >
                      <div className="container-fluid">
                        <div className="row g-2">
                          <div className="col-md-6">
                            <div className="article-card">
                              <div className="card-header-section">
                                <div className="snowFlake-background"></div>
                                <div className="KnowledgeSharingSection">
                                  <div>
                                    <img
                                      src={SnowflakeIcon}
                                      alt="image"
                                      className="knowledgeIcon"
                                    />
                                  </div>
                                  <h5 className="text-white mt-2">
                                    SnowFlake
                                  </h5>
                                </div>
                              </div>

                              <div className="card-content">
                                <div>
                                  <div className="d-flex justify-content-between">
                                    <p className="p-0 m-0">
                                      <b>{snowFlake.title || ""}</b>
                                    </p>
                                    <p className="p-0 m-0">
                                      {snowFlake?.Date &&
                                      moment(snowFlake.Date).isValid()
                                        ? moment(snowFlake.Date).format(
                                            "DD-MMM-YYYY"
                                          )
                                        : ""}
                                    </p>
                                  </div>
                                  <p className="content-text">
                                    {(() => {
                                      const text = (
                                        snowFlake?.Message || ""
                                      ).trim();
                                      const isLargeScreen =
                                        window.innerWidth >= 1600;
                                      const max = 160;

                                      if (isLargeScreen) {
                                        return text;
                                      } else {
                                        return text.length > max
                                          ? text.slice(0, max) + "..."
                                          : text;
                                      }
                                    })()}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-end">
                                  {snowFlake?.FilePath ? (
                                    <a
                                      href={snowFlake.FilePath}
                                      target="_blank"
                                      className="btn"
                                      style={{
                                        backgroundColor: "#3781E2",
                                        border: "none",
                                        color: "#fff",
                                        fontWeight: "500",
                                        padding: "7px 20px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      Open
                                    </a>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="article-card">
                              <div className="card-header-section">
                                <div className="banner-background AI-background"></div>
                                <div className="KnowledgeSharingSection">
                                  <div>
                                    <img
                                      src={AIIcon}
                                      alt="image"
                                      className="knowledgeIcon"
                                    />
                                  </div>
                                  <h5 className="text-white mt-2">
                                    Weekly Dose Of AI
                                  </h5>
                                </div>
                              </div>

                              <div className="card-content">
                                <div className="d-flex justify-content-between">
                                  <p className="p-0 m-0">
                                    <b>{weeklyDose.title || ""}</b>
                                  </p>
                                  <p className="p-0 m-0">
                                    {weeklyDose?.Date &&
                                    moment(weeklyDose.Date).isValid()
                                      ? moment(weeklyDose.Date).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>

                                <p className="content-text">
                                  {(() => {
                                    const text = (
                                      weeklyDose?.Message || ""
                                    ).trim();
                                    const isLargeScreen =
                                      window.innerWidth >= 1600;
                                    const max = 140;

                                    if (isLargeScreen) {
                                      return text;
                                    } else {
                                      return text.length > max
                                        ? text.slice(0, max) + "..."
                                        : text;
                                    }
                                  })()}
                                </p>

                                <div className="d-flex justify-content-end">
                                  {weeklyDose?.FilePath ? (
                                    <a
                                      href={weeklyDose.FilePath}
                                      target="_blank"
                                      className="btn"
                                      style={{
                                        backgroundColor: "#3781E2",
                                        border: "none",
                                        color: "#fff",
                                        fontWeight: "500",
                                        padding: "7px 20px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      Open
                                    </a>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row g-2 mt-1">
                          <div className="col-md-6">
                            <div className="article-card">
                              <div className="card-header-section">
                                <div className="banner-background IT-background"></div>
                                <div className="KnowledgeSharingSection">
                                  <div>
                                    <img
                                      src={ITTipsIcon}
                                      alt="image"
                                      className="knowledgeIcon"
                                    />
                                  </div>
                                  <h5 className="text-white mt-2">IT Tips</h5>
                                </div>
                              </div>

                              <div className="card-content">
                                <div className="d-flex justify-content-between">
                                  <p className="p-0 m-0">
                                    <b>{itTips.title || ""}</b>
                                  </p>
                                  <p className="p-0 m-0">
                                    {itTips?.Date &&
                                    moment(itTips.Date).isValid()
                                      ? moment(itTips.Date).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>

                                <p className="content-text">
                                  {(() => {
                                    const text = (itTips?.Message || "").trim();
                                    const isLargeScreen =
                                      window.innerWidth >= 1600;
                                    const max = 140;

                                    if (isLargeScreen) {
                                      return text;
                                    } else {
                                      return text.length > max
                                        ? text.slice(0, max) + "..."
                                        : text;
                                    }
                                  })()}
                                </p>

                                <div className="d-flex justify-content-end">
                                  {itTips?.FilePath ? (
                                    <a
                                      href={itTips.FilePath}
                                      target="_blank"
                                      className="btn"
                                      style={{
                                        backgroundColor: "#3781E2",
                                        border: "none",
                                        color: "#fff",
                                        fontWeight: "500",
                                        padding: "7px 20px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      Open
                                    </a>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="article-card">
                              <div className="card-header-section">
                                <div className="banner-background admin-background"></div>
                                <div className="KnowledgeSharingSection">
                                  <div>
                                    <img
                                      src={AdminIcon}
                                      alt="image"
                                      className="knowledgeIcon"
                                    />
                                  </div>
                                  <h5 className="text-white mt-2">
                                    Admin Tips
                                  </h5>
                                </div>
                              </div>

                              <div className="card-content">
                                <div className="d-flex justify-content-between">
                                  <p className="p-0 m-0">
                                    <b>{adminTips.title || ""}</b>
                                  </p>
                                  <p className="p-0 m-0">
                                    {adminTips?.Date &&
                                    moment(adminTips.Date).isValid()
                                      ? moment(adminTips.Date).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>

                                <p className="content-text">
                                  {(() => {
                                    const text = (
                                      adminTips?.Message || ""
                                    ).trim();
                                    const isLargeScreen =
                                      window.innerWidth >= 1600;
                                    const max = 140;

                                    if (isLargeScreen) {
                                      return text;
                                    } else {
                                      return text.length > max
                                        ? text.slice(0, max) + "..."
                                        : text;
                                    }
                                  })()}
                                </p>

                                <div className="d-flex justify-content-end">
                                  {adminTips?.FilePath ? (
                                    <a
                                      href={adminTips.FilePath}
                                      target="_blank"
                                      className="btn"
                                      style={{
                                        backgroundColor: "#3781E2",
                                        border: "none",
                                        color: "#fff",
                                        fontWeight: "500",
                                        padding: "7px 20px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      Open
                                    </a>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                           <div className="col-md-6">
                            <div className="article-card">
                              <div className="card-header-section">
                                <div className="banner-background powerbyte-background"></div>
                                <div className="KnowledgeSharingSection">
                                  <div>
                                    <img
                                      src={PBIcon}
                                      alt="image"
                                      className="knowledgeIcon"
                                    />
                                  </div>
                                  <h5 className="text-white mt-2">
                                   Power Bytes
                                  </h5>
                                </div>
                              </div>

                              <div className="card-content">
                                <div className="d-flex justify-content-between">
                                  <p className="p-0 m-0">
                                    <b>{powerBytes.title || ""}</b>
                                  </p>
                                  <p className="p-0 m-0">
                                    {powerBytes?.Date &&
                                    moment(powerBytes.Date).isValid()
                                      ? moment(powerBytes.Date).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>

                                <p className="content-text">
                                  {(() => {
                                    const text = (
                                      powerBytes?.Message || ""
                                    ).trim();
                                    const isLargeScreen =
                                      window.innerWidth >= 1600;
                                    const max = 140;

                                    if (isLargeScreen) {
                                      return text;
                                    } else {
                                      return text.length > max
                                        ? text.slice(0, max) + "..."
                                        : text;
                                    }
                                  })()}
                                </p>

                                <div className="d-flex justify-content-end">
                                  {powerBytes?.FilePath ? (
                                    <a
                                      href={powerBytes.FilePath}
                                      target="_blank"
                                      className="btn"
                                      style={{
                                        backgroundColor: "#3781E2",
                                        border: "none",
                                        color: "#fff",
                                        fontWeight: "500",
                                        padding: "7px 20px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      Open
                                    </a>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="article-card">
                              <div className="card-header-section">
                                <div className="banner-background powerbyte-background"></div>
                                <div className="KnowledgeSharingSection">
                                  <div>
                                    <img
                                      src={DSPulseIcon}
                                      alt="image"
                                      className="knowledgeIcon"
                                    />
                                  </div>
                                  <h5 className="text-white mt-2">
                                   DS Pulse
                                  </h5>
                                </div>
                              </div>

                              <div className="card-content">
                                <div className="d-flex justify-content-between">
                                  <p className="p-0 m-0">
                                    <b>{dsPulse.title || ""}</b>
                                  </p>
                                  <p className="p-0 m-0">
                                    {dsPulse?.Date &&
                                    moment(dsPulse.Date).isValid()
                                      ? moment(dsPulse.Date).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>

                                <p className="content-text">
                                  {(() => {
                                    const text = (
                                      dsPulse?.Message || ""
                                    ).trim();
                                    const isLargeScreen =
                                      window.innerWidth >= 1600;
                                    const max = 140;

                                    if (isLargeScreen) {
                                      return text;
                                    } else {
                                      return text.length > max
                                        ? text.slice(0, max) + "..."
                                        : text;
                                    }
                                  })()}
                                </p>

                                <div className="d-flex justify-content-end">
                                  {dsPulse?.FilePath ? (
                                    <a
                                      href={dsPulse.FilePath}
                                      target="_blank"
                                      className="btn"
                                      style={{
                                        backgroundColor: "#3781E2",
                                        border: "none",
                                        color: "#fff",
                                        fontWeight: "500",
                                        padding: "7px 20px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      Open
                                    </a>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="text-end mt-2">
                          <button
                            className="custom-btn"
                            onClick={() => navigate("/knowledge-sharing")}
                          >
                            View All
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-4 mt-3 mt-lg-0 ps-0 ps-lg-2 pe-0">
            <AlertSection alerts={alert} />
            <LeaderboardSection
              uniqueRanksThreeMonths={uniqueRanksThreeMonths}
              uniqueRanksSixMonths={uniqueRanksSixMonths}
              uniqueRanksTwelveMonths={uniqueRanksTwelveMonths}
              leaderOpen={leaderOpen}
              toggleLeaderOpen={toggleLeaderOpen}
            />
            <CelebrationSection
              birthday={birthday}
              anniversaries={anniversaries}
            />
            <LeaveSummarySection
              leaveData={leaveData}
              leaveOpen={leaveOpen}
              toggleLeaveOpen={toggleLeaveOpen}
            />
          </div>
        </div>
      </div>
      <Modal
        show={showDeleteModal}
        size="md"
        onHide={() => setShowDeleteModal(false)}
        centered
        backdrop="static"
      >
        <div
          style={{
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
            border: "none",
            overflow: "hidden",
          }}
        >
          {/* Header with Icon */}
          <Modal.Header
            style={{
              borderBottom: "none",
              justifyContent: "center",
              paddingBottom: "0",
              paddingTop: "32px",
              backgroundColor: "#ffffff",
            }}
          >
            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "44px",
                  height: "44px",
                  backgroundColor: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "12px",
                  color: "#dc2626",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <i
                  className="bi bi-trash3-fill"
                  style={{
                    fontSize: "22px",
                  }}
                ></i>
              </div>

              {/* Title */}
              <h3
                style={{
                  fontWeight: "600",
                  color: "#1f2937",
                  fontSize: "20px",
                  margin: "0",
                }}
              >
                Delete Confirmation
              </h3>
            </div>
          </Modal.Header>

          {/* Body */}
          <Modal.Body
            style={{
              backgroundColor: "#ffffff",
              padding: "4px 10px",
              fontSize: "15px",
              color: "#6b7280",
              textAlign: "center",
              lineHeight: "1.5",
            }}
          >
            Are you sure you want to delete this item? This action cannot be
            undone.
          </Modal.Body>

          {/* Footer */}
          <Modal.Footer
            style={{
              borderTop: "none",
              justifyContent: "center",
              padding: "14px",
              gap: "12px",
              backgroundColor: "#ffffff",
            }}
          >
            <button
              style={{
                backgroundColor: "#f3f4f6",
                border: "1px solid #e5e7eb",
                padding: "6px 18px",
                borderRadius: "8px",
                fontWeight: "500",
                color: "#374151",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </button>
            <button
              style={{
                backgroundColor: "#27568B",
                border: "none",
                padding: "6px 18px",
                borderRadius: "8px",
                fontWeight: "500",
                color: "#ffffff",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onClick={async () => {
                setShowDeleteModal(false);
                await handleDeleteReply(
                  selectedReply.feedId,
                  selectedReply.replyId
                );
              }}
            >
              Delete
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default Dashboard;
